export class GenProfileSectionEntity{
    id:number;
    profileId:number;
    sectionId:number;

    constructor(){}
}